const API_URL = process.env.REACT_APP_API_URL;

const GetQuestions = async () => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/questions`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener preguntas.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const SubmitQuiz = async (payload) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/submit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const resData = await response.json();
        if (!response.ok) {
            return { success: false, message: resData.message || 'Error al enviar la trivia.', code: resData.code };
        }
        return { success: true, data: resData };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const GetSettings = async () => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/settings`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener settings.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const GetAdminParticipants = async () => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/participants`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener participantes.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const ToggleVisibility = async (id) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/participants/${id}/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar visibilidad.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const SelectWinner = async (id) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/participants/${id}/select-winner`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al seleccionar ganador.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdatePosition = async (offset) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/position?offset=${offset}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar la posición.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdateBannerMode = async (mode) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/banner-mode?mode=${mode}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar el modo del banner.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const UpdateOverlayVisibility = async (visible) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/overlay-visibility?visible=${visible}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar la visibilidad del overlay.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const ToggleActiveTrivia = async (active) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/toggle-active?active=${active}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al cambiar el estado de la trivia.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const TrackMetric = async (eventName, sessionId, source) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ eventName, sessionId, source })
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al guardar métrica.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const GetAdminStats = async () => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/stats`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al obtener estadísticas.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const CheckDuplicateParticipant = async (email, phone) => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/check-duplicate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, phone })
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al verificar duplicidad.' };
        }
        const data = await response.json();
        return { success: true, exists: data.exists };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const ResetRubaQuizData = async () => {
    try {
        const response = await fetch(`${API_URL}RubaQuiz/admin/reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        if (!response.ok) {
            const err = await response.json();
            return { success: false, message: err.message || 'Error al reiniciar la dinámica.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

export {
    GetQuestions,
    SubmitQuiz,
    GetSettings,
    GetAdminParticipants,
    ToggleVisibility,
    SelectWinner,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    ToggleActiveTrivia,
    TrackMetric,
    GetAdminStats,
    CheckDuplicateParticipant,
    ResetRubaQuizData
};
